const _excluded = ["templates", "thesauris", "settings", "excludePreview"],_excluded2 = ["additionalMetadata", "sortedProperty", "entity", "relationships"];function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import { metadataSelectors } from "../selectors";
import Metadata from "../components/Metadata";

const removeUneededProps = (_ref) => {let { templates, thesauris, settings, excludePreview } = _ref,rest = _objectWithoutProperties(_ref, _excluded);return rest;};

const BaseFormatMetadata = (_ref2) => {let {
      additionalMetadata,
      sortedProperty,
      entity,
      relationships

    } = _ref2,props = _objectWithoutProperties(_ref2, _excluded2);return /*#__PURE__*/(
    React.createElement(Metadata, _extends({
      metadata: additionalMetadata.concat(
      metadataSelectors.formatMetadata(props, entity, sortedProperty, relationships, {
        excludePreview: props.excludePreview
      })),

      templateId: entity.template,
      compact: !!sortedProperty },
    removeUneededProps(props))));};



BaseFormatMetadata.defaultProps = {
  sortedProperty: '',
  additionalMetadata: [],
  relationships: Immutable.fromJS([]),
  excludePreview: false
};


























export function mapStateToProps(state, { entity, sortedProperty = '' }) {
  return {
    templates: state.templates,
    thesauris: state.thesauris,
    settings: state.settings.collection,
    entity,
    sortedProperty
  };
}

export const FormatMetadata = connect(mapStateToProps)(BaseFormatMetadata);